module.exports = __webpack_public_path__ + "fonts/manrope-light.c0aa06ca.otf";